import React from "react";
import classes from "./HRange.module.css";

type Props = {
    id: string;
    min: number;
    max: number;
    step: number;
    value: number;
    onChange: (event: React.FormEvent<HTMLInputElement>) => void;
};

const HRange: React.FC<Props> = (props) => {
    const progressValue = (100 * (props.value - props.min)) / (props.max - props.min);
    let styles = {
        background: `linear-gradient(to right, #844 0%, #844 ${progressValue}%, white ${progressValue}%, white 100%)`
    };
    return (
        <div className={classes.HRangeContainer}>
            <input
                id={props.id}
                type="range"
                min={props.min}
                max={props.max}
                step={props.step}
                value={props.value}
                onChange={props.onChange}
                className={classes.HRange}
                style={styles}
            />
        </div>
    );
};

export default HRange;
